/* eslint-disable */
(function landingtabContent($, Drupal) {

  function showHideTab(tabId) {
    // remove active tab link and set new one.
    $('.landing-tab__link').each(function(){
      $(this).removeClass('landing-tab__link--active');

      // Apply new active tab.
      if ($(this).attr('href') == tabId) {
        $(this).addClass('landing-tab__link--active');
      }
    })

    // Hide old content.
    $('.landing-tab__content').fadeOut(100);

    // Show new content.
    $(tabId).fadeIn(100);
  }

  $(document).ready(function() {

      $('.landing-tab__link').on('click', function(e) {

        // trigger only with link hash.
        if ($(this).attr('href').startsWith("#")) {
          let tabId = $(this).attr('href');
          window.location.hash = tabId;
          e.preventDefault();
    
          showHideTab(tabId);
    
          setTimeout(function() {
            window.scrollTo(0, 0);
          }, .1);
        }
        
      });
      if (window.location.hash) {

        if ($('.landing-tab').length) {

          if (location.hash) {
            setTimeout(function() {
              window.scrollTo(0, 0);
            }, 1);
          }  
          
          if (window.location.hash) {

            let pageHash = window.location.hash;
            showHideTab(pageHash);
          }
      
        }

    }
  });

  Drupal.behaviors.landingtabContent = {
    attach(context) {
      
      // Custom Search Bar
      const searchInput = $('.input-search--secondary', context).find('input[type=search]');
      const search = $('.input-search__button--secondary', context);
      let searchValue;

      search.click((e) => {
        e.preventDefault();
        // If user does not enter value in search input, define default search value.
        if (searchInput.val() === '') {
          searchValue = '';
        }
        else {
          searchValue = searchInput.val();
        }

        // Determine the search page using the input id and value.
        window.location.href = `/${searchInput.attr('id')}/?title=${searchValue}`;
      });
    },
  };
}(jQuery, Drupal));
/* eslint-enable */
